var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { Divider } from "../divider";
import { makeStyles } from "../styles";
import clsx from "../utils/clsx";
var dropdownMenuDividerComponentName = "QuantumDropdownMenuDivider";
var useDropdownMenuDividerStyles = makeStyles(function (theme) { return ({
    root: {
        margin: theme.spacing(1),
    },
}); }, { name: dropdownMenuDividerComponentName });
export var DropdownMenuDivider = React.forwardRef(function (props, ref) {
    var classes = useDropdownMenuDividerStyles(props);
    var className = props.className, propClasses = props.classes, rootProps = __rest(props, ["className", "classes"]);
    return React.createElement(Divider, __assign({ ref: ref, component: "hr", role: "separator", className: clsx(classes.root, className) }, rootProps));
});
